











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Login from '@/components/auth/Login.vue';
import SignUp from '@/components/auth/SignUp.vue';

@Component({
  components: {
    Login,
    SignUp,
  },
})
export default class Authentication extends Vue {
  public isLogInShown: boolean = true;

  public showLogIn() {
    if (!this.isLogInShown) {
      this.toggle();
    }
  }

  public showSignUp() {
    if (this.isLogInShown) {
      this.toggle();
    }
  }

  @Watch('$store.getters.user')
  public onUserChange() {
    const user = this.$store.getters.user;
    if (user && user.id) {
      this.$router.push('/dataStream');
    }
  }

  private toggle() {
    this.isLogInShown = !this.isLogInShown;
  }
}
